import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import useCloseFriends from "hooks/useCloseFriends"
import { useAppSelector } from "appRedux/hooks"
import CTA from "components/atoms/CTA"
import UsersList from "components/organisms/UsersList"
import { useLazyGetFollowersQuery } from "appRedux/slices/userApiSlice"

export default function CloseFriendsList() {
  const userProfile = useAppSelector((state) => state.user.profile)

  const [triggerGetFollowers] = useLazyGetFollowersQuery()

  const { isFetching, closeFriends } = useCloseFriends()

  const { t } = useTranslation()
  const navigate = useNavigate()

  function handleEditCloseFriends() {
    if (!userProfile?.id) return
    triggerGetFollowers(userProfile?.id)
    navigate(`/user/${userProfile?.handle}/close-friends`)
  }

  return (
    <Stack>
      <TopBarContainer>
        <Count>{closeFriends?.length} {t("connections.friend")}</Count>

        <CTA
          variant="text"
          loading={false}
          onClick={handleEditCloseFriends}
        >
          {t("general.edit")}
        </CTA>
      </TopBarContainer>
      <UsersList
        users={closeFriends}
        loading={isFetching}
        style={{
          height: "calc(100vh - 448px)",
          overflow: "scroll"
        }}
      />
    </Stack>
  )
}

const TopBarContainer = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",

  "& button": {
    width: "40px",
    minWidth: "unset",
    fontSize: "1.2rem"
  }
}))

const Count = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 400,
  color: theme.palette.gray["12"],
  fontFamily: "VazirmatnFD, serif !important"
}))
